import { useState } from 'react';

import TituloSessao from "../componentes/TituloSessao";

import { MENU_CONFIGURACOES } from '../componentes/configuracoes/menuConfiguracoes';

function Configuracoes() {

    const [selected, setSelected] = useState(MENU_CONFIGURACOES[0].submenus[0].id);
    const todosSubmenus = MENU_CONFIGURACOES?.flatMap(menu => menu.submenus) ?? [];
    const Componente = todosSubmenus.find(submenu => submenu.id === selected).componente;
    const titulo = todosSubmenus.find(submenu => submenu.id === selected)?.nome;

    return (
        <div>
            <TituloSessao
                titulo='Configurações'
                barraDecorativa={false}
                tituloAlignStar={false}
            />
            <div className='container d-flex flex-column mt-1'>
                <div className='d-flex justify-content-start bg-color-menu'>
                    <nav className="navbar navbar-expand-sm p-1">
                        <div className="">
                            <button
                                className="navbar-toggler"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#navBarMenuConfiguracoes"
                                aria-controls="navBarMenuConfiguracoes"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div
                                className="collapse navbar-collapse"
                                id="navBarMenuConfiguracoes"
                            >
                                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                    {MENU_CONFIGURACOES.map((menu) => (
                                        <li key={menu.id} className="nav-item dropdown">
                                            <a
                                                className="nav-link dropdown-toggle"
                                                id="navbarDropdown"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                {menu.nome}
                                            </a>
                                            <ul
                                                className="dropdown-menu bg-color-menu"
                                                aria-labelledby="navbarDropdown"
                                            >
                                                {menu.submenus.map((submenu) =>
                                                    <li key={submenu.id}>
                                                        <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            onClick={() => setSelected(submenu.id)}
                                                        >
                                                            {submenu.nome}
                                                        </button>
                                                    </li>
                                                )}
                                            </ul>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
                {selected &&
                    <div className="w-100 mt-3">
                        <Componente />
                    </div>
                }
            </div>
        </div>
    );
}

export default Configuracoes